import { Component, OnInit, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';

import { environment } from '../../environments/environment';
import { AppSettingsService } from '../services/app-settings.service';
declare var $: any;

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
})
export class PagesComponent implements OnInit {
  app = {
    group: 'manufacturing',
    name: 'Manufacturing',
  };

  position = 0;

  private scrollEvent$;
  private resizeEvent$;

  private topPosition;

  public datum: string;
  public verzija: string;

  constructor(
    private eRef: ElementRef,
    private appSettingsService: AppSettingsService
  ) {
    const that = this;

    // this.scrollEvent$ = Observable.fromEvent($(window), 'scroll').subscribe(
    //   (event: any) => {
    //     this.handler(event);
    //   }
    // );
    this.resizeEvent$ = Observable.fromEvent($(window), 'resize')
      .debounceTime(250)
      .subscribe((event: any) => {
        $('.popup').removeClass('show');
        $('.combo-component').removeClass('open');
        // this.scrollEvent$.unsubscribe();
        //     $('.filter-row').removeClass('closed');
        //     $('.filter-row').addClass('opened');
        // $('.filter-row').removeClass('sticked');
        //     $('.sticking .pagination-main-table').removeClass('filter-closed');
        //     $('.sticking .pagination-main-table').removeClass('up');
        //     $('.sticking .pagination-main-table').addClass('down');
        //     $('.sticking .pagination-main-table').removeClass('sticked');
        //     $('.sticking .pagination-main-table.sticked.table').css('top', '150px');

        //     $('.sticking .thead-wrapper-main-table').removeClass('filter-closed');
        //     $('.sticking .thead-wrapper-main-table').removeClass('up');
        //     $('.sticking .thead-wrapper-main-table').addClass('down');
        //     $('.sticking .thead-wrapper-main-table').removeClass('sticked');
        //     $('.sticking .tbody-wrapper-main-table').removeClass('sticked');
        // $('.sticking .thead-wrapper-main-table.sticked.table').css(
        //   'top',
        //   '200px'
        // );
        //   $(window).scrollTop(0);
        //   setTimeout(function() {
        //     that.scrollEvent$ = Observable.fromEvent(
        //       $(window),
        //       'scroll'
        //     ).subscribe((e: any) => {
        //       that.handler(e);
        //     });
        //   }, 0);
      });
  }

  handler(event) {
    // this.topPosition = $('.pagination-main-table.table').css('top');
    // $('.popup').removeClass('show');
    // $('.combo-component').removeClass('open');
    // if ($('.active.page-content-wrap .main-panel-table-mode').length === 0) {
    //   return;
    // }
    // const scroll = $(window).scrollTop();
    // if (
    //   scroll === 0 &&
    //   $(window).height() === document.documentElement.scrollHeight
    // ) {
    //   return;
    // }
    // if (scroll > this.position) {
    //   if (scroll > 250 && scroll - this.position > 20) {
    //     $('.filter-row').removeClass('opened');
    //     $('.filter-row').addClass('closed');
    //     $('.sticking .pagination-main-table').addClass('filter-closed');
    //     $('.sticking .pagination-main-table').removeClass('down');
    //     $('.sticking .pagination-main-table').addClass('up');
    //     $('.sticking .thead-wrapper-main-table').addClass('filter-closed');
    //     $('.sticking .thead-wrapper-main-table').removeClass('down');
    //     $('.sticking .thead-wrapper-main-table').addClass('up');
    //     $('.sticking .tbody-wrapper-main-table').addClass('filter-closed');
    //   }
    //   $('.filter-row').addClass('sticked');
    //   $('.sticking .pagination-main-table').addClass('sticked');
    //   $('.sticking .thead-wrapper-main-table').addClass('sticked');
    //   $('.sticking .tbody-wrapper-main-table').addClass('sticked');
    // } else {
    //   if (scroll - this.position < -20 || scroll <= 250) {
    //     $('.filter-row').removeClass('closed');
    //     $('.filter-row').addClass('opened');
    //     $('.sticking .pagination-main-table').removeClass('filter-closed');
    //     $('.sticking .pagination-main-table').removeClass('up');
    //     $('.sticking .pagination-main-table').addClass('down');
    //     // $('.sticking .thead-wrapper-main-table').removeClass('filter-closed');
    //     // $('.sticking .thead-wrapper-main-table').removeClass('up');
    //     // $('.sticking .thead-wrapper-main-table').addClass('down');
    //     $('.sticking .tbody-wrapper-main-table').removeClass('filter-closed');
    //   }
    //   if (scroll === 0) {
    //     $('.filter-row').removeClass('sticked');
    //     $('.sticking .pagination-main-table').removeClass('sticked');
    //     $('.sticking .thead-wrapper-main-table').removeClass('sticked');
    //     $('.sticking .tbody-wrapper-main-table').removeClass('sticked');
    //   }
    // }
    // if (
    //   $('.pagination-main-table:visible').length > 0 &&
    //   !$('.pagination-main-table.sticked.table').hasClass('filter-closed')
    // ) {
    // for (let i = 1; i < 20; i++) {
    //   if ($('.pagination-main-table:visible').length > 0) {
    //     $('.sticking .pagination-main-table.sticked.table.filter' + i).css(
    //       'top',
    //       150 + 40 * (i - 1) + 'px'
    //     );
    //     $('.sticking .thead-wrapper-main-table.sticked.filter' + i).css(
    //       'top',
    //       200 + 40 * (i - 1) + 'px'
    //     );
    //   } else {
    //     $('.sticking .thead-wrapper-main-table.sticked.filter' + i).css(
    //       'top',
    //       100 + 40 * (i - 1) + 'px'
    //     );
    //   }
    // }
    // } else {
    //   if ($('.sticking .pagination-main-table:visible').length > 0) {
    //     // $('.sticking .pagination-main-table.sticked.table').css('top', '150px');
    //     // $('.sticking .thead-wrapper-main-table.sticked').css('top', '200px');
    //   } else {
    //     // $('.sticking .thead-wrapper-main-table.sticked').css('top', '100px');
    //   }
    // }
    // this.position = scroll;
  }

  ngOnInit() {
    this.appSettingsService.getConfigFromFile().subscribe(file => {
      this.datum = file.datum;
      this.verzija = file.verzija;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts